import { createApp } from 'vue'
import TeikibinPopup from '~/js/components/teikibinPopup'
const CLASS_NAME_TEIKIBIN_PRODUCT_POPUP = 'js-teikibin-product-popup'

document.addEventListener('DOMContentLoaded', () => {
  const elementsTeikibinProductPopup = document.getElementsByClassName(
    CLASS_NAME_TEIKIBIN_PRODUCT_POPUP
  )
  if (!elementsTeikibinProductPopup.length) return

  Array.from(elementsTeikibinProductPopup).forEach((element) => {
    const eventName = element.dataset.eventName || ''

    createApp({
      name: 'BlocksTeikibinProductPopup',
      components: {
        TeikibinPopup,
      },
      data() {
        return {
          isShow: false,
        }
      },
      created() {
        window.addEventListener(eventName, () => {
          this.isShow = true
        })
      },
    }).mount(element)
  })
})
